import styled from 'styled-components';
import { Header5 } from '@ardoq/typography';
import { FlexBox } from '@ardoq/layout';
import { colors } from '@ardoq/design-tokens';

type LineSeparatorWithTextProps = {
  text: string;
};

export const LineSeparatorWithText = ({ text }: LineSeparatorWithTextProps) => {
  return (
    <FlexBox align="center" gap="small">
      <Line />
      <Header5 color="textSubtle">
        <NoWrapText>{text}</NoWrapText>
      </Header5>
      <Line />
    </FlexBox>
  );
};

const Line = styled.div`
  border-bottom: 1px solid ${colors.borderAction};
  height: 1px;
  width: 100%;
`;

const NoWrapText = styled.span`
  text-wrap: nowrap;
`;
